import {MessageCodes} from "../MessageCodes";
import Constants from "../Constants";
import ResultHeader from "../../Table/ResultHeader";
import ResultRow from "../../Table/ResultRow";
import ResultBody from "../../Table/ResultBody";
import ResultBodyCell from "../../Table/ResultBodyCell";
import ResultHeaderCell from "../../Table/ResultHeaderCell";
import ResultTable from "../../Table/ResultTable";
import ResultText from "../ResultText";
import ComparisonCSName from "../../ComparisonCSName";
import DeckRoadwayEditor from "../UI/DeckRoadwayEditor";
import {useModal} from "../../../Context/ModalContext";
import DeckRoadwayWindow from "../UI/DeckRoadwayWindow";
import EmptyLine from "../../EmptyLine";

const RenderDescription = ({text, row, settings, globalVariables}) => {
    switch (row.error_id) {
        case MessageCodes.Compare.CD001.error_id: {

            return (
                <>
                    <StructureDiffs row={row}/>
                </>
            )
        }
        default: {
            return `Error Key Not Found: ${row.error_id}`
        }
    }
}

const filterItem = ({name, base, compare}) => {
    if(!base || !compare)
        return false

    return true
}

const renderItem = ({name, base, compare}) => {
    if((!base && !compare) || (base === '*' && compare === '*'))
        return name
    else if(base && !compare)
        return `${name} (${base}/None)`
    else if(!base && compare)
        return `${name} (None/${compare})`

    return `${name} (${base}/${compare})`
}

const StructureDiffs = ({row}) => {
    const {openModal, closeModal} = useModal();
    return (
        <>
            <ResultText>
                {
                    row.data.filter(x => x.structure_diffs).map(x => {
                        const data = x?.structure_diffs;
                        if(!data || data.length < 5) {
                            return ''
                        }

                        return (
                            <>
                                <ResultText>
                                    There are following differences in the structure geometry of the {x.type} at RS {<ComparisonCSName csName={x.cross_section} />}:
                                    <EmptyLine />
                                </ResultText>
                                {
                                    data[0]?.length > 0 && (
                                        <ResultTable>
                                            <ResultHeader>
                                                <ResultRow>
                                                    <ResultHeaderCell style={{textAlign: 'start', width: '18cm'}}>
                                                        <a
                                                            onClick={() => {
                                                                openModal({
                                                                    title: 'Deck/Roadway Data',
                                                                    component: <DeckRoadwayWindow
                                                                        data={row}
                                                                        selected={x.cross_section}
                                                                    />,
                                                                    style: {
                                                                        width: 1020
                                                                    }
                                                                })
                                                            }}
                                                        >
                                                            Bridge/Culvert | Deck/Roadway
                                                        </a>
                                                    </ResultHeaderCell>
                                                </ResultRow>
                                            </ResultHeader>
                                            <ResultBody>
                                                <ResultRow>
                                                    <ResultBodyCell>
                                                        {data[0].map(renderItem).join(', ')}
                                                    </ResultBodyCell>
                                                </ResultRow>
                                            </ResultBody>
                                        </ResultTable>
                                    )
                                }
                                {
                                    data[1]?.length > 0 && (
                                        <ResultTable style={{minWidth: '18cm', maxWidth: '18cm'}}>
                                            <ResultHeader>
                                                <ResultRow>
                                                    <ResultHeaderCell style={{textAlign: 'start'}} colspan={2}>
                                                        Bridge/Culvert | Culvert
                                                    </ResultHeaderCell>
                                                </ResultRow>
                                            </ResultHeader>
                                            <ResultBody>
                                                {
                                                    data[1].map((x, idx) => {
                                                        return (
                                                            <ResultRow>
                                                                <ResultBodyCell style={{width: '4cm', border: 'none', borderBottom: '1px solid #e0e0e0',}}>{x.culvert}</ResultBodyCell>
                                                                <ResultBodyCell style={{width: '14cm', borderBottom: '1px solid #e0e0e0',}}>{x.diffs.map(renderItem).join(', ')}</ResultBodyCell>
                                                            </ResultRow>
                                                        )
                                                    })
                                                }
                                            </ResultBody>
                                        </ResultTable>
                                    )
                                }
                                {
                                    data[2]?.length > 0 && (
                                        <ResultTable style={{minWidth: '18cm', maxWidth: '18cm'}}>
                                            <ResultHeader>
                                                <ResultRow>
                                                    <ResultHeaderCell style={{textAlign: 'start'}} colspan={2}>
                                                        Bridge/Culvert | Pier
                                                    </ResultHeaderCell>
                                                </ResultRow>
                                            </ResultHeader>
                                            <ResultBody>
                                                {
                                                    data[2].map((x, idx) => {
                                                        return (
                                                            <ResultRow>
                                                                <ResultBodyCell style={{width: '4cm', verticalAlign: 'top'}}>{x.pier}</ResultBodyCell>
                                                                <ResultBodyCell style={{width: '14cm', verticalAlign: 'top'}}>{x.diffs.map(renderItem).join(', ')}</ResultBodyCell>
                                                            </ResultRow>
                                                        )
                                                    })
                                                }
                                            </ResultBody>
                                        </ResultTable>
                                    )
                                }
                                {
                                    data[3]?.length > 0 && (
                                        <ResultTable style={{minWidth: '18cm', maxWidth: '18cm'}}>
                                            <ResultHeader>
                                                <ResultRow>
                                                    <ResultHeaderCell style={{textAlign: 'start'}} colspan={2}>
                                                        Bridge/Culvert | Sloping Abutment
                                                    </ResultHeaderCell>
                                                </ResultRow>
                                            </ResultHeader>
                                            <ResultBody>
                                                {
                                                    data[3].length > 0 && data[3].map((x, idx) => {
                                                        return (
                                                            <ResultRow>
                                                                <ResultBodyCell style={{width: '4cm'}}>{x.abutment}</ResultBodyCell>
                                                                <ResultBodyCell style={{width: '14cm', }}>{x.diffs.map(x => x.name).join(', ')}</ResultBodyCell>
                                                            </ResultRow>
                                                        )
                                                    })
                                                }
                                            </ResultBody>
                                        </ResultTable>
                                    )
                                }
                                {
                                    data[4]?.length > 0 && (
                                        <ResultTable style={{minWidth: '18cm', maxWidth: '18cm'}}>
                                            <ResultHeader>
                                                <ResultRow>
                                                    <ResultHeaderCell style={{textAlign: 'start'}} colspan={2}>
                                                        Inline Structure
                                                    </ResultHeaderCell>
                                                </ResultRow>
                                            </ResultHeader>
                                            <ResultBody>
                                                {
                                                    data[4].length > 0 && data[4].map((x, idx) => {
                                                        return (
                                                            <ResultRow>
                                                                <ResultBodyCell style={{width: '4cm'}}>Inline Structure</ResultBodyCell>
                                                                <ResultBodyCell style={{width: '14cm', }}>
                                                                    {data[4].map(renderItem).join(', ')}
                                                                </ResultBodyCell>
                                                            </ResultRow>
                                                        )
                                                    })
                                                }
                                            </ResultBody>
                                        </ResultTable>
                                    )
                                }
                                <EmptyLine />
                            </>
                        )
                    })
                }
            </ResultText>
        </>
    )
}

export const C4 = {
    RenderDescription,
}